import { token } from '@bynder/design-system';

export type ColorOption = {
  label: string;
  value: string;
};

export const DEFAULT_COLOR_OPTIONS: ColorOption[] = [
  { label: 'Black', value: token.gray1000 },
  { label: 'Blue', value: token.brandPrimary500 },
  { label: 'White', value: token.gray10 },
  { label: 'Red', value: token.red500 },
  { label: 'Teal', value: token.teal500 },
  { label: 'Purple', value: token.purple500 },
  { label: 'Magenta', value: token.magenta500 },
  // @ts-expect-error orange500 is named in the design system but not included in this version of the DS package. Adding fallback hex value that we can remove once it's been added officially
  { label: 'Orange', value: token.orange500 ?? '#FFA037' },
];
